import { render, staticRenderFns } from "./Gre.vue?vue&type=template&id=65cbbcb4&scoped=true&"
import script from "./Gre.vue?vue&type=script&lang=js&"
export * from "./Gre.vue?vue&type=script&lang=js&"
import style0 from "./Gre.vue?vue&type=style&index=0&id=65cbbcb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cbbcb4",
  null
  
)

export default component.exports